// source: https://bootstrap-autocomplete.readthedocs.io/en/latest/

up.compiler('.autocomplete', (element) => {
  filterQuery = element.getAttribute('data-filter')+'?q=#QUERY#';
  element.setAttribute('autocomplete', 'off')
  element.setAttribute('data-url', filterQuery)
  $(element).autoComplete();
})
